import OwnerCard from "./OwnerCard";

function OwnerSkeleton() {
  return (
    <div className="flex min-w-[250px] flex-1 animate-pulse items-center gap-3 rounded-xl border border-slate-200 bg-slate-50 p-3">
      <div className="h-10 w-10 rounded-xl bg-slate-200" />
      <div className="flex-1 space-y-2">
        <div className="h-3 w-24 rounded bg-slate-200" />
        <div className="h-2.5 w-36 rounded bg-slate-100" />
      </div>
    </div>
  );
}

export default function OwnersCardsCarousel({ owners = [], loading = false, stages = [] }) {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 [scrollbar-width:thin]">
      {loading
        ? <><OwnerSkeleton /><OwnerSkeleton /></>
        : owners.map((owner) => <OwnerCard key={owner?.user?.id || owner?.user_id} owner={owner} stages={stages} />)}
    </div>
  );
}
